"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PROVIDER_TYPE = exports.LOCATION_ENTITY_TYPE = exports.ENTITY_TYPE = exports.COVID_VACCINE_PROVIDER_TYPE = void 0;
const ENTITY_TYPE = exports.ENTITY_TYPE = 'entity_type';
const LOCATION_ENTITY_TYPE = exports.LOCATION_ENTITY_TYPE = 'location';
const PROVIDER_TYPE = exports.PROVIDER_TYPE = 'provider_type';
const COVID_VACCINE_PROVIDER_TYPE = exports.COVID_VACCINE_PROVIDER_TYPE = 'Vaccine Clinic - COVID-19';